export const AUTH_TOKEN = '__DESPERTA_SALESFORCE_TOKEN__'
export * from './uf'
